import { useSyncExternalStore } from 'react';
import { Download } from 'lucide-react';
import {
  applyPwaUpdate,
  isPwaUpdateReady,
  subscribePwaUpdate,
} from '../lib/pwaUpdate';

export function PwaUpdateToast() {
  const ready = useSyncExternalStore(subscribePwaUpdate, isPwaUpdateReady);

  if (!ready) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] flex items-center gap-3 bg-gray-900 dark:bg-gray-800 text-white rounded-full shadow-xl pl-4 pr-2 py-2 border border-gray-700">
      <Download className="w-4 h-4 text-indigo-400 flex-shrink-0" />
      <span className="text-sm text-gray-100">New version available</span>
      <button
        onClick={() => applyPwaUpdate()}
        className="text-sm font-medium bg-indigo-600 hover:bg-indigo-500 text-white rounded-full px-3 py-1 transition-colors"
      >
        Refresh
      </button>
    </div>
  );
}
